<template>
  <el-select
    v-model="service"
    filterable
    :disabled="disabled"
    :loading="serviceLoading"
    placeholder="Gépelj a kereséshez..."
    size="small"
    style="width: 100%;"
    value-key="id"
    @change="onServiceChange"
  >
    <el-option
      v-for="s in services"
      :key="s.id"
      :value="s"
      :label="s.name"
    />
  </el-select>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
      required: false,
    },
    defaultService: {
      type: Object,
      default() {
        return null;
      },
      required: false,
    },
  },
  data() {
    return {
      serviceLoading: false,
      service: {},
    };
  },
  computed: {
    services() {
      return this.$store.getters['service/rawServices'];
    },
  },
  async mounted() {
    if (this.services && this.services.length === 0) {
      await this.$store.dispatch('service/fetchAllRaw');
    }
    this.service = this.defaultService || {};
    this.onServiceChange();
  },
  methods: {
    onServiceChange() {
      this.$emit('change', this.service);
    },
    async searchService(query) {
      if (query !== '') {
        this.serviceLoading = true;
        this.services = await this.$store.dispatch('service/search', '?name=' + query);
        this.serviceLoading = false;
      }
    },
  },
};
</script>
